"use client";
import {
  DividerComponent,
  LoaderComponent,
  ModalComponent,
  PaperComponent,
  SnackbarComponent,
} from "@/components";
import { useRouter } from "@/i18n/routing";
import {
  CurrencyConverter,
  errorValidator,
  GET_PRODUCT_APPLICATION,
  IMAGES,
  MaskStringUptoLastChars,
  PRODUCT_HANDLER,
  REPAYMENT_SETUP_NOTIFICATION,
  STAGE,
  STAGE_BASED_ROUTING,
  SUBSTAGE,
  toTitleCase,
  WEB_COLORS,
} from "@/lib/constants";
import { useFooter } from "@/lib/context/FooterContext";
import {
  useBankMandateStatusMutation,
  useGetApplicationQuery,
} from "@/lib/redux";
import {
  useGetApplicationStageConfigQuery,
  useGetRepaymentSetupApiQuery,
} from "@/lib/redux/apis/los-api";
import { Info } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslations } from "next-intl";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import ErrorModal from "../repayment-mode/error-modal";
import useErrorHandling from "@/lib/hooks/errorhandling";
import { checkForRpl } from "@/lib/utils/rpl.utils";
import { sessionStorageUtil } from "@/lib/utils/common.utils";
import Image from "next/image";

const DetailField = ({ label = "", value = "" }) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      {label && value && (
        <>
          <Typography
            textAlign={"left"}
            sx={{
              fontSize: { xs: 12, md: 16 },
            }}
            color={WEB_COLORS.mainColorShade2}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 12, md: 16 },
            }}
            textAlign={"end"}
            fontWeight={500}
            color={WEB_COLORS.primary}
          >
            {value}
          </Typography>
        </>
      )}
    </Stack>
  );
};

const RepaymentSetup = ({ product }) => {
  const t = useTranslations("repaymentSetUp");
  const router = useRouter();
  const { setActions } = useFooter();
  const [modalVisible, setModalVisible] = useState(false);
  const [errorModalDetails, setErrorModalDetails] = useState({
    label: "",
    subLabel: "",
    modalErrorType: "",
    buttonLabel: "Retry",
  });
  const [openCalculationModal, setOpenCalculationModal] = useState(false);
  /***************************************RTK************************************ */
  const {
    data: applicationData,
    error: errorGetApplication,
    isLoading: applicationLoading,
    refetch: refetchApplicationData,
    isSuccess: isSuccessApplication,
  } = useGetApplicationQuery("", { refetchOnMountOrArgChange: true });

  // const {
  //   data: mandateCalculationData,
  //   error: errorMandateCalculation,
  //   isLoading: mandateCalculationLoading,
  // } = useMandateCalculationQuery();
  const [
    mandateStatus,
    {
      data: mandateStatusData,
      error: errorMandateStatus,
      isError: isErrorMandate,
      isSuccess: isSuccessMandate,
      isLoading: mandateStatusLoading,
    },
  ] = useBankMandateStatusMutation();
  const productApplication = GET_PRODUCT_APPLICATION(
    PRODUCT_HANDLER[product],
    applicationData?.data,
  );
  const isRPL = checkForRpl(productApplication);

  const {
    data: appStageConfigData,
    isLoading: isLoadingAppStageConfig,
    error: appStageConfigError,
    refetch: refetchAppStageConfig,
  } = useGetApplicationStageConfigQuery(
    {
      appId: productApplication?.appId,
      stage: productApplication?.stage,
    },
    {
      skip: !productApplication?.appId || !productApplication?.stage,
      refetchOnMountOrArgChange: true,
    },
  );

  const {
    data: repaymentData,
    error: errorRepayment,
    isLoading: repaymentLoading,
  } = useGetRepaymentSetupApiQuery(
    { appId: productApplication?.appId },
    { skip: !isSuccessApplication },
  );

  const isError = errorGetApplication || errorRepayment || errorMandateStatus;
  const isloading =
    applicationLoading || repaymentLoading || mandateStatusLoading;

  const handleProceed = () => {
    router.push(`/${product}/mandate/repayment-mode`);
  };

  // [0] = current month, [1] = +1, [2] = +2, [3] = +3 (long month names)
  const upcomingMonths = Array.from({ length: 4 }, (_, i) => {
    const d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + i);
    return d.toLocaleString("default", { month: "long" });
  });
  const handleOnMandateFailed = () => {
    setModalVisible(false);
    if (mandateStatusData?.data?.subStage === SUBSTAGE?.MANADATE_FAILED) {
      sessionStorageUtil.remove("mandateId");
    }
  };

  /***************************************EFFECT************************************ */
  useErrorHandling(isError);

  useEffect(() => {
    // if (window !== undefined) {
    //   if (!isRPL && sessionStorageUtil?.has(APP_KEYS.MANDATE_ID) && productApplication?.appId) {
    //     const requestData = {
    //       appId: productApplication?.appId,
    //       mandateId: sessionStorageUtil?.get(APP_KEYS.MANDATE_ID),
    //     };
    //     mandateStatus(requestData);
    //   }
    // }
    if (
      productApplication?.previousStage === STAGE?.CREDIT_QUEUE &&
      productApplication?.subStage !== SUBSTAGE.PENNYDROP_RETRY &&
      !sessionStorageUtil?.has(APP_KEYS.MANDATE_ID)
    ) {
      enqueueSnackbar(
        "Verification Successful!. You can now continue with your loan application.",
        { variant: "success", autoHideDuration: 3000, preventDuplicate: true },
      );
    }
  }, [productApplication?.appId, isRPL]);
  useEffect(() => {
    if (
      mandateStatusData &&
      mandateStatusData?.data &&
      mandateStatusData?.data?.stage
    ) {
      // setShowLoading(false);
      if (
        mandateStatusData?.data?.stage !== null &&
        mandateStatusData?.data?.stage === STAGE?.MANDATE
      ) {
        setErrorModalDetails({
          modalErrorType: "mandateFailed",
          onBtnClick: handleOnMandateFailed,
        });
        setModalVisible(true);
      } else if (
        mandateStatusData?.data?.stage !== null &&
        mandateStatusData?.data?.stage === STAGE?.CREDIT_QUEUE
      ) {
        setErrorModalDetails({
          modalErrorType: "mandateFailedWithCreditQueue",
        });
        setModalVisible(true);
      } else if (
        mandateStatusData?.data?.stage !== null &&
        mandateStatusData?.data?.stage === STAGE?.E_SIGN
      ) {
        SnackbarComponent({
          success: true,
          successMessage: "E-mandate has been completed.",
        });
        refetchApplicationData(); //navigate to esign page
      }
    }
  }, [mandateStatusData, errorMandateStatus]);
  useEffect(() => {
    if (
      isRPL &&
      productApplication?.stage === STAGE.MANDATE &&
      productApplication?.subStage &&
      appStageConfigData
    ) {
      const subStage = productApplication?.subStage;
      const hasMandateAwaitingSubStage =
        appStageConfigData?.data?.subStageHold?.includes(subStage);
      if (hasMandateAwaitingSubStage) {
        // for RPL, for certain substages on mandate Stage needs to be rerouted to penny drop
        router.push(STAGE_BASED_ROUTING(STAGE.MANDATE_PENNYDROP));
        return;
      }
    }
    if (productApplication?.stage) {
      router.push(STAGE_BASED_ROUTING(productApplication?.stage));
    }
  }, [
    productApplication?.stage,
    productApplication?.subStage,
    appStageConfigData,
    isRPL,
  ]);

  useEffect(() => {
    if (isError) {
      if (isError?.status === 401) {
        SnackbarComponent({
          error: isError,
          errorMessage: "Your session has expired. Please login again",
        });
        sessionStorage.clear();
        router.refresh();
      } else {
        if (isError) {
          SnackbarComponent({
            error: isError,
            errorMessage: errorValidator(isError),
          });
          return;
        }
        SnackbarComponent({
          error: isError,
          errorMessage: "Something Went wrong. Please try again",
        });
      }
    }
  }, [isError]);

  useEffect(() => {
    setActions({
      onConfirm: handleProceed,
    });
  }, [setActions]);
  /***************************************ACTION************************************ */
  const onPressErrorButton = (errorType) => {
    setModalVisible(false);
    if (errorType === "mandateFailedWithCreditQueue") {
      router.push("/"); //naviagte to home beacuse we don't have home dashboard
    }
  };
  /***************************************RENDER************************************ */
  return (
    <Stack spacing={2} mb={2}>
      <LoaderComponent open={isloading} />
      <PaperComponent>
        <Stack spacing={2}>
          <Stack marginLeft={-1.5}>
            <Typography
              sx={{
                fontSize: { xs: 18, md: 24 },
                fontWeight: 700,
                color: WEB_COLORS.primary,
              }}
            >
              {t("header")}
            </Typography>
            <Typography
              fontSize={{ xs: 14, md: 16 }}
              color={"rgba(31, 31, 31, 0.8)"}
            >
              {t("tittle")}
            </Typography>
          </Stack>
          {/* <DividerComponent orientation="horizontal" /> */}

          <PaperComponent noDrop paperStyle={{ backgroundColor: "#E5F1F1" }}>
            {/* Bank / Customer Details */}

            <Stack rowGap={2} my={1}>
              {repaymentData?.data?.repaymentSetup?.bankName ? (
                <>
                  <DetailField
                    label="A/C Holder Name"
                    value={toTitleCase(
                      repaymentData?.data?.repaymentSetup?.accountHolderName ??
                        "",
                    )}
                  />
                  <DetailField
                    label="Account Number"
                    value={
                      repaymentData?.data?.repaymentSetup?.accountNumber ?? ""
                    }
                  />
                  <DetailField
                    label="Bank Name"
                    value={repaymentData?.data?.repaymentSetup?.bankName ?? ""}
                  />
                  <DetailField
                    label="IFSC Code"
                    value={repaymentData?.data?.repaymentSetup?.ifsc ?? ""}
                  />
                </>
              ) : (
                <DetailField
                  label={t("customerName")}
                  value={toTitleCase(
                    repaymentData?.data?.repaymentSetup?.customerName ?? "",
                  )}
                />
              )}

              <DetailField
                label={t("emiAmount")}
                value={CurrencyConverter(
                  repaymentData?.data?.repaymentSetup?.emiAmount ?? 0,
                )}
              />
              <DetailField
                label={t("disbursementAmount")}
                value={CurrencyConverter(
                  repaymentData?.data?.repaymentSetup?.disbursementAmount ?? 0,
                )}
              />
              <DetailField
                label={t("emiStartDate")}
                value={repaymentData?.data?.repaymentSetup?.emiStartDate ?? ""}
              />
              <DetailField
                label={t("emiEndDate")}
                value={repaymentData?.data?.repaymentSetup?.emiEndDate ?? ""}
              />
            </Stack>
            <Button
              onClick={() => {
                setOpenCalculationModal(true);
              }}
              sx={{
                textTransform: "capitalize",
                size: "small",
                textDecoration: "underline",
                fontSize: { xs: 10, md: 12 },
                m: 0,
                p: 0,
              }}
            >
              How is my First Emi Calculated?
            </Button>
          </PaperComponent>

          <Stack>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <IconButton
                sx={{
                  color: "#FFC700",
                  p: 0,
                  width: "14px",
                }}
              >
                <Info />
              </IconButton>
              <Typography
                textTransform={"capitalize"}
                fontSize={14}
                color={WEB_COLORS.textFadeColor}
              >
                {t("note")}
              </Typography>
            </Stack>
            <Stack>
              <List
                sx={{
                  listStyleType: "decimal",
                  pl: 2.5,
                  "& .MuiListItem-root": {
                    display: "list-item",
                    paddingLeft: 0.5,
                  },
                  color: WEB_COLORS.textFadeColor,
                  "& .MuiListItem-root::marker": {
                    fontSize: { xs: "12px", md: "14px" },
                  },
                }}
              >
                {REPAYMENT_SETUP_NOTIFICATION().map(({ sNo, text }) => (
                  <ListItem key={sNo} disablePadding>
                    <Typography
                      sx={{
                        fontSize: { xs: 12, md: 14 },
                      }}
                      color={WEB_COLORS.textFadeColor}
                    >
                      {text}
                    </Typography>
                  </ListItem>
                ))}
              </List>
            </Stack>
          </Stack>
        </Stack>
      </PaperComponent>
      <ErrorModal
        open={modalVisible}
        handleModal={setModalVisible}
        data={errorModalDetails}
        onPress={() => {
          onPressErrorButton(errorModalDetails?.modalErrorType);
        }}
      />
      <Dialog
        open={openCalculationModal}
        onClose={() => setOpenCalculationModal(false)}
      >
        <DialogTitle sx={{ position: "relative" }}>
          How is my first EMI Calculated
        </DialogTitle>
        <Image
          src={IMAGES.close}
          alt="Close"
          onClick={() => setOpenCalculationModal(false)}
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 18,
            right: 14,
            zIndex: 1000,
          }}
          height={25}
          width={25}
        />
        <DialogContent>
          <PaperComponent noDrop paperStyle={{ backgroundColor: "#F7FAFA" }}>
            <Typography color={WEB_COLORS.textFadeColor} variant="caption">
              CASE 1 : If your disbursal date is 1st to 3rd {upcomingMonths[0]}
            </Typography>
            <Typography>
              {" "}
              1st EMI on 3rd {upcomingMonths[1]} → Pre-EMI + EMI
            </Typography>
          </PaperComponent>
          <PaperComponent noDrop paperStyle={{ backgroundColor: "#F7FAFA" }}>
            <Typography color={WEB_COLORS.textFadeColor} variant="subtitle1">
              CASE 2 : If your disbursal date is 4th to 24th {upcomingMonths[0]}
            </Typography>
            <Typography>3rd {upcomingMonths[1]} → Pre-EMI</Typography>
            <Typography>3rd {upcomingMonths[2]} → First EMI</Typography>
          </PaperComponent>
          <PaperComponent noDrop paperStyle={{ backgroundColor: "#F7FAFA" }}>
            <Typography color={WEB_COLORS.textFadeColor} variant="subtitle1">
              CASE 3 : If your disbursal date is 25th {upcomingMonths[0]} to end
              of month
            </Typography>
            <Typography>
              {" "}
              1st EMI on 3rd {upcomingMonths[2]} → Pre-EMI + EMI
            </Typography>
          </PaperComponent>

          <PaperComponent noDrop paperStyle={{ backgroundColor: "#FFFAEA" }}>
            <Stack direction={"row"} alignItems={"center"} gap={1} mb={1}>
              <Info color="#000" />
              <Typography fontWeight={500}>
                From 2nd EMI onwards only EMI{" "}
                {CurrencyConverter(
                  repaymentData?.data?.repaymentSetup?.emiAmount,
                )}{" "}
                will be deducted
              </Typography>
            </Stack>
          </PaperComponent>
          <PaperComponent noDrop paperStyle={{ backgroundColor: "#E9FFE6" }}>
            <Typography>What is Pre-EMI ?</Typography>
            <Typography color={WEB_COLORS.textFadeColor}>
              Interest charged from the loan disbursement date until EMI begins.
            </Typography>
            <Stack
              direction={"row"}
              alignItems={"center"}
              gap={1}
              mt={1}
              color="#FFC700"
            >
              <Info color="inherit" />{" "}
              <Typography color={"#000"}>NOTE:</Typography>
            </Stack>
            <Typography color={WEB_COLORS.textFadeColor}>
              Final payment schedule will be confirmed after signing the Loan
              Agreement.
            </Typography>
          </PaperComponent>
        </DialogContent>
      </Dialog>
    </Stack>
  );
};

export default RepaymentSetup;
